import styled from "styled-components";
import {
  greenColor,
  greyColor,
  questionDarkTextColor,
  whiteColor,
} from "../../../constants/colors";

const RadioBlock = styled.div`
  width: 100%;
  height: 52px;
  background: ${(props) => (props.isActive ? greenColor : greyColor)};
  transition: ${(props) => (props.isActive ? "0s" : "0.1s")};
  border-radius: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:active {
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgb(0 0 0 / 10%);
  }
  p {
    transition: 0.3s;
    color: ${(props) => (props.isActive ? whiteColor : questionDarkTextColor)};
  }
`;

export { RadioBlock };
